<template>
    <component v-if="icon" :is="icon" :size="size" :style="iconStyles"/>
</template>

<script setup>
import { computed } from 'vue';
import * as icons from 'lucide-vue';

// Props
const props = defineProps({
    name: {
        type: String,
        default: ''
    },
    size: {
        type: Number,
        default: 16
    }
});

// Computed
const icon = computed(() => {
    if (icons[props.name]) {
        return icons[props.name]
    } else {
        return props.name
    }
})
const iconStyles = computed(() => ({
    width: `${props.size}px`,
    height: `${props.size}px`,
    // fill: props.color,
    // stroke: props.color.value,
}));

</script>
